import templateUrl from './employee-work-order-list-modal.component.html'

export const EmployeeWorkOrderListModalComponent = {
    controller: EmployeeWorkOrdersListController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
};

function EmployeeWorkOrdersListController() {
    'ngInject';

    const vm = this;
    vm.selectedWorkOrder;
    vm.onViewBreakDown = onViewBreakDown;
    vm.onViewList = onViewList;
    vm.$onInit = onInit;

    function onInit() {
        vm.workOrders = vm.resolve.employee.WorkOrders;
        vm.onDismiss = function () {
            vm.dismiss({ $value: 'cancel' });
        };
    }

    function onViewBreakDown(workOrder) {
        vm.selectedWorkOrder = workOrder;
    }

    function onViewList() {
        vm.selectedWorkOrder = null;

    }

}

